import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../common/http/http-utils';
import { getTimezone } from '../../dataprotection-common/utils';
@Injectable()

export class ReplicatedService {
    value = '';
    constructor(public http: HttpClient) {}
    getReplicatedVdcs() {
        return this.http
        .get(HttpUtils.getBaseUrl() + '/hybridity/api/dps/replicatedVdcs')
        .map(
            (res: any) => this.value = res
        );
    }
    getReplicatedVApps(vdcId) {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/replicatedVdc/' + vdcId + '/replicatedVApps?timezone=' + encodeURIComponent(getTimezone());
        return this.http
        .get(url)
        .map(
            (res: any) => this.value = res
        );
    }
    getReplicatedRestorePointsForVapp(vappId, vdcId) {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/replicatedVdc/' + vdcId + '/replicatedVApp/' + vappId + '/replicatedVAppRestorePoints?timezone=' + encodeURIComponent(getTimezone());
        return this.http
        .get(url)
        .map(
            (res: any) => this.value = res
        );
    }
    runOutOfPlaceRestore(targetVdcId, obj) {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + targetVdcId + '/restore';
        return this.http
        .post(url, JSON.stringify(obj))
        .map(
            (res: any) => this.value = res
        );
    }
    getRestoreTargetVDCs(restorePointId) {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/replicatedRestorePointId/' + restorePointId + '/restoreTargetVdcs';
        return this.http
        .get(url)
        .map(
            (res: any) => this.value = res
        );
    }
    getReplicationSites() {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/replicationSites';
        return this.http
        .get(url)
        .map(
            (res: any) => this.value = res
        );
    }
    configureDestinationCloud(data) {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/configureCloud';
        return this.http
        .post(url, JSON.stringify(data))
        .map(
            (res: any) => this.value = res
        );
    }
    configureReplicationForVDC(data, vdcId) {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/'+vdcId+'/replicationPolicy';
        if ( data && data.retention ) {
            data.retention.days = 50; // dummy retention value since removed retention field from UI
        }
        return this.http
        .post(url, JSON.stringify(data))
        .map(
            (res: any) => this.value = res
        );
    }
    editReplicationForVDC(data, vdcId) {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/'+vdcId+'/replicationPolicy';
        if ( data && data.retention ) {
            data.retention.days = 50; // dummy retention value since removed retention field from UI
        }
        return this.http
        .put(url, JSON.stringify(data))
        .map(
            (res: any) => this.value = res
        );
    }
    removeReplicationPolicyForVDC(vdcId) {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/'+vdcId+'/replicationPolicy';
        return this.http
        .delete(url)
        .map(
            (res: any) => this.value = res
        );
    }
    applyReplicationForVapp(data, vdcId, vappId) {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/'+vdcId+'/vapp/'+vappId+'/replicationPolicy';
        if ( data && data.retention ) {
            data.retention.days = 50; // dummy retention value since removed retention field from UI
        }
        return this.http
        .post(url, JSON.stringify(data))
        .map(
            (res: any) => this.value = res
        );
    }
    editReplicationForVapp(data, vdcId, vappId) {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/'+vdcId+'/vapp/'+vappId+'/replicationPolicy';
        if ( data && data.retention ) {
            data.retention.days = 50; // dummy retention value since removed retention field from UI
        }
        return this.http
        .put(url, JSON.stringify(data))
        .map(
            (res: any) => this.value = res
        );
    }
    removeReplicationForVapp(vdcId, vappId) {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/'+vdcId+'/vapp/'+vappId+'/replicationPolicy';
        return this.http
        .delete(url)
        .map(
            (res: any) => this.value = res
        );
    }
    replicateNow(data, vdcId, vappId) {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/vapp/' + vappId+ '/replicate';
        return this.http
        .post(url, JSON.stringify(data))
        .map(
            (res: any) => this.value = res
        );
    }
    logError(error, origin: String = '') {
        console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
    }
    logOperationCompleted(msg: string) {
        console.log('Operation Completed: ', msg);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/replicated-vdc/replicated.service.ts